export default __webpack_public_path__ + "static/media/Motilal_Oswal_Nifty_Capital_Market_Index.8cbde2c2.png";